export default __webpack_public_path__ + "small-rocket-ship-silhouette.png";